import React from 'react'
import { Col, Container } from 'react-awesome-styled-grid'
import reactHtmlParser from 'react-html-parser'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Layout from '~/components/Layout'
import NotFoundError from '~/components/NotFoundError'

/**
 * StaticPageLayout
 */

const StaticPageLayout = ({ data, isMobile }) => {
  const hasContent = !isEmpty(data)
  const { content, title } = data

  return (
    <Layout isMobile={isMobile}>
      {!hasContent && <NotFoundError />}
      {hasContent && (
        <Container>
          <Col sm={12} md={10} lg={8}>
            <h1>{title}</h1>
            {reactHtmlParser(content)}
            <VSpacer />
          </Col>
        </Container>
      )}
    </Layout>
  )
}

/**
 * PropTypes
 */

StaticPageLayout.propTypes = {
  data: PropTypes.object,
  isMobile: PropTypes.bool,
}

/**
 * Styles
 */

const VSpacer = styled.div`
  height: 50px;
`

/**
 * Exports
 */

export default StaticPageLayout
